<div class="d-inline-flex tag" [ngClass]='tagClass'>
  <span *ngIf="icon" class="pe-1">
    <i class="bi bi-{{ icon }}"></i>
  </span>
  <span>{{ label }}</span>
</div>
